import React from "react";

const PreviewContext = React.createContext(false);

export default PreviewContext;
